import { render, staticRenderFns } from "./JobCardModuleContent.vue?vue&type=template&id=780f344d&scoped=true"
import script from "./JobCardModuleContent.vue?vue&type=script&lang=js"
export * from "./JobCardModuleContent.vue?vue&type=script&lang=js"
import style0 from "./JobCardModuleContent.vue?vue&type=style&index=0&id=780f344d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780f344d",
  null
  
)

export default component.exports